exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".HqS1OEbeSDnXKkw31xNxr{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);
// Exports
exports.locals = {
	"container": "HqS1OEbeSDnXKkw31xNxr"
};